export default __webpack_public_path__ + "static/media/rage-of-the-sea.add7f6d4.jpg";